var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SsrCarousel',{attrs:{"show-arrows":"","paginate-by-slide":"","slides-per-page":1}},_vm._l((_vm.images.slice().reverse()),function(image,index){return _c('Slide',{key:index,attrs:{"src":image}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }